import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {ItemInformation} from 'components/common/ItemInformation'
import {Avatar} from "antd";
import {FaMedal} from "react-icons/fa6";
import {formatSimplifyDate} from "../../../helpers/dateUtils";

const MedalDetail = ({item}) => {
    const t = useTranslate()
    return (
        <div className="border rounded m-2 p-2 space-y-2">
            student: {getTitle(item)}
        </div>
    )
}

const renderMedalAward = ({translate: t, isLg, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {medal, notes, visible, eff_date, ref} = item ?? {}
    const {owner} = item ?? {}

    return (
        <div
            key={index}
            className="p-4 flex flex-col md:flex-row gap-3 md:gap-4 custom-item-render relative list-item border-b border-color-50 last:border-b-0">
            <div
                className="flex-shrink-0 rounded-xl p-[3px]"
                style={{background: 'linear-gradient(135deg, #facc15, #f97316)'}}>
                <Avatar
                    src={medal?.avatar}
                    shape="square"
                    style={{width: isLg ? 160 : '100%', minHeight: 120, maxHeight: 200}}
                    icon={<FaMedal size={50} className="text-color-500"/>}
                    className="flex flex-center background-000 rounded-lg"
                />
            </div>
            <div className="flex flex-col flex-1 min-w-0 gap-2">
                <div className="text-sm text-color-100 leading-relaxed">
                    {t(
                        "The certificate {medal} was awarded to {receiver_type} {receiver} for completing {reference}.",
                        {
                            medal: <span className="font-bold text-green-600">{getTitle(medal)}</span>,
                            receiver_type: '',
                            receiver: <span className="font-semibold">{t('you')}</span>,
                            reference: (
                                <Link
                                    to={getLinkToDetail(ref)}
                                    className="font-bold text-color-000 no-underline">
                                    {getTitle(ref)}
                                </Link>
                            ),
                        }
                    )}
                </div>
                <div className="flex items-center gap-1.5 text-xs text-color-300">
                    <span>{t('organized by')}</span>
                    <Link to={getLinkToDetail(medal?.owner)} className="font-semibold text-blue-600 no-underline">
                        {getTitle(medal?.owner)}
                    </Link>
                </div>
                <ItemInformation
                    showIcon={true} label="date of award"
                    value={formatSimplifyDate(eff_date, 'medium')}
                    className="text-xs text-color-400"
                />
            </div>
        </div>
    )
}

export default renderMedalAward
